function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M648.343 429.253L128.343 414.353C104.143 413.653 84.2435 395.153 81.8435 371.053L56.7435 123.053C53.9435 94.953 75.7435 70.453 103.943 70.053L682.743 62.053C711.943 61.653 734.843 87.153 731.243 116.153L697.543 387.053C694.443 411.653 673.143 429.953 648.343 429.253Z",
  fill: "#D2E0F6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M648.343 429.253L128.343 414.353C104.143 413.653 84.2435 395.153 81.8435 371.053L56.7435 123.053C53.9435 94.953 75.7435 70.453 103.943 70.053L682.743 62.053C711.943 61.653 734.843 87.153 731.243 116.153L697.543 387.053C694.443 411.653 673.143 429.953 648.343 429.253Z",
  fill: "#EAF9F3"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_301_3671)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M479.344 496.553H63.8435C55.5435 496.553 48.8435 489.853 48.8435 481.553V245.853C48.8435 237.553 55.5435 230.853 63.8435 230.853H479.344C487.644 230.853 494.344 237.553 494.344 245.853V481.453C494.344 489.753 487.644 496.553 479.344 496.553Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M785.043 480.653H661.043C652.743 480.653 646.043 473.953 646.043 465.653V121.353C646.043 113.053 652.743 106.353 661.043 106.353H785.043C793.343 106.353 800.043 113.053 800.043 121.353V465.653C800.043 473.953 793.343 480.653 785.043 480.653Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M141.943 160.453H52.0435V151.553H141.943C142.943 151.553 143.743 152.353 143.743 153.353V158.553C143.843 159.653 143.043 160.453 141.943 160.453Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M125.744 151.653H105.444C103.244 151.653 101.444 150.053 101.144 147.853L99.5435 133.453C99.2435 130.953 101.244 128.653 103.844 128.653H127.344C129.944 128.653 131.844 130.853 131.644 133.453L130.044 147.853C129.744 149.953 127.944 151.653 125.744 151.653Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M113.143 128.653C113.143 128.653 105.143 127.853 103.543 117.053C103.543 117.053 110.743 119.153 113.043 124.253C113.043 124.253 114.043 112.853 119.443 111.753C119.443 111.753 121.843 120.253 118.043 124.453C118.043 124.453 120.943 119.653 128.343 119.753C128.343 119.753 126.443 126.553 119.143 128.553",
  fill: "#77A1E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M476.244 280.553H386.044C383.744 280.553 381.844 278.653 381.844 276.353V248.953C381.844 246.653 383.744 244.753 386.044 244.753H476.244C478.544 244.753 480.444 246.653 480.444 248.953V276.353C480.444 278.653 478.544 280.553 476.244 280.553Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M441.444 254.453H420.644C419.844 254.453 419.144 253.753 419.144 252.953C419.144 252.153 419.844 251.453 420.644 251.453H441.444C442.244 251.453 442.944 252.153 442.944 252.953C442.944 253.753 442.344 254.453 441.444 254.453Z",
  fill: "#77A1E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M476.244 326.353H386.044C383.744 326.353 381.844 324.453 381.844 322.153V294.753C381.844 292.453 383.744 290.553 386.044 290.553H476.244C478.544 290.553 480.444 292.453 480.444 294.753V322.153C480.444 324.453 478.544 326.353 476.244 326.353Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M441.444 300.253H420.644C419.844 300.253 419.144 299.553 419.144 298.753C419.144 297.953 419.844 297.253 420.644 297.253H441.444C442.244 297.253 442.944 297.953 442.944 298.753C442.944 299.553 442.344 300.253 441.444 300.253Z",
  fill: "#77A1E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M123.443 280.553H33.2435C30.9435 280.553 29.0435 278.653 29.0435 276.353V248.953C29.0435 246.653 30.9435 244.753 33.2435 244.753H123.443C125.743 244.753 127.643 246.653 127.643 248.953V276.353C127.743 278.653 125.843 280.553 123.443 280.553Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.7435 254.453H67.9435C67.1435 254.453 66.4435 253.753 66.4435 252.953C66.4435 252.153 67.1435 251.453 67.9435 251.453H88.7435C89.5435 251.453 90.2435 252.153 90.2435 252.953C90.2435 253.753 89.5435 254.453 88.7435 254.453Z",
  fill: "#77A1E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M123.443 326.353H33.2435C30.9435 326.353 29.0435 324.453 29.0435 322.153V294.753C29.0435 292.453 30.9435 290.553 33.2435 290.553H123.443C125.743 290.553 127.643 292.453 127.643 294.753V322.153C127.743 324.453 125.843 326.353 123.443 326.353Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.7435 300.253H67.9435C67.1435 300.253 66.4435 299.553 66.4435 298.753C66.4435 297.953 67.1435 297.253 67.9435 297.253H88.7435C89.5435 297.253 90.2435 297.953 90.2435 298.753C90.2435 299.553 89.5435 300.253 88.7435 300.253Z",
  fill: "#77A1E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M827.244 211.253H667.444C664.944 211.253 662.844 209.153 662.844 206.653V126.953C662.844 124.453 664.944 122.353 667.444 122.353H827.344C829.844 122.353 831.944 124.453 831.944 126.953V206.653C831.844 209.153 829.844 211.253 827.244 211.253Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M827.244 310.153H667.444C664.944 310.153 662.844 308.053 662.844 305.553V225.853C662.844 223.353 664.944 221.253 667.444 221.253H827.344C829.844 221.253 831.944 223.353 831.944 225.853V305.553C831.844 308.153 829.844 310.153 827.244 310.153Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M703.343 160.953H693.443V211.253H703.343V160.953Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M713.643 174.653H703.344V211.253H713.643V174.653Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M697.243 266.453L698.343 251.553C698.443 250.553 697.643 249.753 696.643 249.753H692.343H688.043C687.043 249.753 686.343 250.553 686.343 251.553L687.443 266.453C687.443 266.453 678.443 272.253 678.543 277.053C678.643 280.753 680.843 298.453 681.843 306.253C682.143 308.453 683.943 310.053 686.143 310.053H692.343H698.543C700.743 310.053 702.543 308.453 702.843 306.253C703.843 298.453 706.043 280.753 706.143 277.053C706.243 272.253 697.243 266.453 697.243 266.453Z",
  fill: "#77A1E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M72.9435 404.553H717.143",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M358.144 89.753L264.444 101.753C260.244 102.253 256.044 98.853 255.644 94.553L245.744 6.75299C245.244 2.65299 248.544 -0.447012 252.744 0.0529885L346.544 12.053C350.044 12.453 353.044 15.453 353.644 18.853L363.344 82.653C363.844 86.253 361.644 89.253 358.144 89.753Z",
  fill: "#F8AB5D"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M361.944 89.753L268.244 101.753C264.044 102.253 259.844 98.853 259.344 94.553L249.344 6.75299C248.844 2.65299 252.144 -0.447012 256.344 0.0529885L350.144 12.053C353.644 12.453 356.644 15.453 357.244 18.853L367.044 82.653C367.644 86.253 365.444 89.353 361.944 89.753Z",
  fill: "#22272E"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M290.044 32.653C293.044 31.553 294.244 27.253 290.944 22.853C285.944 18.753 281.244 21.753 281.844 26.553C282.144 29.153 284.044 31.453 286.244 32.453C282.144 33.053 279.044 36.253 278.344 40.653L299.444 41.253C297.844 37.053 294.244 33.653 290.044 32.653Z",
  fill: "#FFE7CA"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M309.344 26.253L343.744 28.753",
  stroke: "#F8AB5D",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M310.443 34.453L344.843 36.153",
  stroke: "#F8AB5D",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M294.844 69.953C297.844 68.453 299.044 63.853 295.644 59.653C290.644 55.853 285.944 59.553 286.544 64.453C286.844 67.153 288.744 69.353 291.044 70.153C286.944 71.153 283.844 74.853 283.144 79.553L304.244 77.953C302.644 73.653 298.944 70.453 294.844 69.953Z",
  fill: "#FFE7CA"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M314.144 61.153L348.344 60.253",
  stroke: "#F8AB5D",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M315.244 69.653L349.544 67.853",
  stroke: "#F8AB5D",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M447.944 164.753L403.144 156.853C398.044 155.953 394.344 150.053 394.844 143.653L403.144 39.053C403.644 32.653 408.244 26.753 413.444 25.853L459.444 17.953C466.244 16.753 471.444 21.953 470.844 29.553L461.044 153.353C460.644 160.753 454.644 165.853 447.944 164.753Z",
  fill: "#22272E"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M444.444 164.753L399.644 156.853C394.544 155.953 390.844 150.053 391.344 143.653L399.644 39.053C400.144 32.653 404.744 26.753 409.944 25.853L455.944 17.953C462.744 16.753 467.944 21.953 467.344 29.553L457.544 153.353C457.144 160.753 451.044 165.853 444.444 164.753Z",
  fill: "#22272E"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M430.944 33.653L422.344 34.853C421.544 34.953 420.844 34.253 420.944 33.253C421.044 32.253 421.744 31.353 422.644 31.253L431.244 29.953C432.144 29.853 432.744 30.553 432.744 31.553C432.644 32.653 431.844 33.553 430.944 33.653Z",
  fill: "#63737A"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M439.644 32.453L438.444 32.653C437.544 32.753 436.844 32.053 436.944 31.053C437.044 30.053 437.844 29.053 438.744 28.953L439.944 28.753C440.844 28.653 441.544 29.353 441.444 30.353C441.444 31.353 440.544 32.253 439.644 32.453Z",
  fill: "#63737A"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M416.144 144.753L401.244 142.653C399.644 142.453 398.444 140.653 398.644 138.653C398.844 136.653 400.244 135.153 401.844 135.353L416.744 137.153C418.444 137.353 419.744 139.253 419.644 141.353C419.444 143.553 417.844 145.053 416.144 144.753Z",
  fill: "#63737A"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M405.744 49.153L427.044 46.753",
  stroke: "#63737A",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M402.144 93.953L412.444 94.053",
  stroke: "#63737A",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M420.444 94.053L431.744 94.153",
  stroke: "#63737A",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M440.644 94.253L453.144 94.353",
  stroke: "#63737A",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M430.344 86.053L405.444 86.353C403.944 86.353 402.844 84.853 403.044 83.053L404.744 61.453C404.844 59.653 406.244 58.053 407.744 57.853L432.844 55.653C434.544 55.453 435.843 56.953 435.643 58.953L433.844 82.353C433.544 84.353 432.044 85.953 430.344 86.053Z",
  fill: "#77A1E3"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M463.044 85.553L446.344 85.753C444.544 85.753 443.144 84.153 443.344 82.153L445.244 58.153C445.444 56.153 447.044 54.353 448.844 54.153L465.644 52.653L463.044 85.553Z",
  fill: "#1D62D1"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M446.844 130.853L402.244 126.653C400.744 126.553 399.744 124.953 399.844 123.053L401.244 105.353C401.344 103.553 402.744 102.053 404.144 102.053L449.044 103.353C450.944 103.453 452.344 105.153 452.144 107.253L450.544 127.453C450.344 129.553 448.744 131.053 446.844 130.853Z",
  fill: "#F7D4D9"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M526.743 166.253L482.143 157.053C477.143 156.053 473.643 150.053 474.143 143.653L482.444 39.053C482.944 32.653 487.443 26.653 492.643 25.653L538.743 16.453C545.743 15.053 551.043 20.153 550.443 27.953L540.443 154.853C539.643 162.553 533.443 167.653 526.743 166.253Z",
  fill: "#22272E"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M523.944 166.253L479.344 157.053C474.344 156.053 470.844 150.053 471.344 143.653L479.644 39.053C480.144 32.653 484.644 26.653 489.844 25.653L535.944 16.453C542.944 15.053 548.244 20.153 547.644 27.953L537.644 154.853C536.844 162.553 530.644 167.653 523.944 166.253Z",
  fill: "#22272E"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M510.444 33.053L501.844 34.453C501.044 34.553 500.444 33.853 500.444 32.853C500.544 31.853 501.244 30.953 502.144 30.753L510.744 29.253C511.644 29.053 512.244 29.853 512.244 30.853C512.044 31.853 511.344 32.853 510.444 33.053Z",
  fill: "#63737A"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M519.144 31.553L517.944 31.753C517.044 31.953 516.344 31.153 516.444 30.153C516.544 29.053 517.344 28.153 518.244 27.953L519.444 27.753C520.344 27.553 521.044 28.353 520.944 29.353C520.944 30.353 520.044 31.353 519.144 31.553Z",
  fill: "#63737A"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M485.444 49.053L506.544 46.353",
  stroke: "#63737A",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M495.544 145.253L480.844 142.853C479.244 142.553 478.144 140.753 478.344 138.753C478.544 136.753 479.844 135.253 481.444 135.553L496.144 137.553C497.844 137.753 499.144 139.753 498.944 141.853C498.844 144.053 497.244 145.553 495.544 145.253Z",
  fill: "#63737A"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M530.043 85.653L485.043 86.353C483.543 86.353 482.543 84.853 482.643 83.053L484.343 61.353C484.443 59.553 485.744 57.853 487.244 57.753L532.543 53.053C534.443 52.853 535.944 54.453 535.744 56.553L533.744 81.653C533.644 83.853 531.943 85.653 530.043 85.653Z",
  fill: "#1D62D1"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M526.743 126.953L482.243 122.553C480.843 122.453 479.743 120.853 479.943 118.953L481.643 97.253C481.743 95.453 483.043 93.953 484.543 93.953L529.443 94.353C531.343 94.353 532.743 96.153 532.643 98.253L530.643 123.353C530.343 125.553 528.643 127.153 526.743 126.953Z",
  fill: "#63737A"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M315.544 95.653C315.544 97.753 317.244 99.353 319.244 99.353H394.844",
  stroke: "#63737A",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M465.644 99.353H474.944",
  stroke: "#63737A",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M229.344 376.853H82.0435C79.6435 376.853 77.6436 374.853 77.6436 372.453C77.6436 370.053 79.6435 368.053 82.0435 368.053H229.344C231.744 368.053 233.744 370.053 233.744 372.453C233.744 374.853 231.744 376.853 229.344 376.853Z",
  fill: "#22272E"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M100.843 376.853H90.0435L89.0435 389.653H99.5435L100.843 376.853Z",
  fill: "#F6AE2D"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M89.0435 389.653L77.4435 543.753C77.3435 545.653 78.7435 547.253 80.6435 547.253C82.3435 547.253 83.7435 545.953 83.8435 544.353L99.5435 389.753H89.0435V389.653Z",
  fill: "#77A1E3"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M210.543 376.853H221.443L222.343 389.653H211.843L210.543 376.853Z",
  fill: "#F6AE2D"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M222.343 389.653L234.043 543.753C234.143 545.653 232.743 547.253 230.843 547.253C229.143 547.253 227.743 545.953 227.643 544.353L211.943 389.753H222.343V389.653Z",
  fill: "#77A1E3"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M385.744 376.853H238.444C236.044 376.853 234.044 374.853 234.044 372.453C234.044 370.053 236.044 368.053 238.444 368.053H385.744C388.144 368.053 390.144 370.053 390.144 372.453C390.144 374.853 388.244 376.853 385.744 376.853Z",
  fill: "#22272E"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M257.344 376.853H246.444L245.444 389.653H256.044L257.344 376.853Z",
  fill: "#F6AE2D"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M245.444 389.653L233.844 543.753C233.744 545.653 235.144 547.253 237.044 547.253C238.744 547.253 240.144 545.953 240.244 544.353L256.044 389.653H245.444Z",
  fill: "#77A1E3"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M366.944 376.853H377.844L378.844 389.653H368.244L366.944 376.853Z",
  fill: "#F6AE2D"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M378.844 389.653L390.444 543.753C390.544 545.653 389.144 547.253 387.244 547.253C385.544 547.253 384.144 545.953 384.044 544.353L368.344 389.753H378.844V389.653Z",
  fill: "#77A1E3"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M625.544 493.753C625.544 493.753 627.044 508.353 627.444 512.253C627.844 515.653 628.544 519.853 629.044 522.553C629.344 524.353 628.844 526.253 627.544 527.553C627.544 527.553 626.944 532.853 627.544 537.853C627.544 537.953 627.544 537.953 627.544 538.053C627.944 541.353 625.644 544.353 622.344 544.853C617.444 545.653 609.444 546.753 600.244 547.053C594.044 547.253 589.144 546.953 585.344 546.453C581.444 545.953 579.444 541.453 581.844 538.353C586.044 532.853 591.744 525.053 594.944 520.353C600.244 512.353 599.544 501.553 598.344 493.653C597.144 485.853 621.144 487.753 625.544 493.753Z",
  fill: "#F7D4D9"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M626.244 500.653C625.844 496.853 625.544 493.753 625.544 493.753C621.244 487.753 597.144 485.853 598.344 493.753C598.944 497.853 599.444 502.853 599.044 507.753C609.144 509.453 620.644 508.053 626.244 500.653Z",
  fill: "#E26E85"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M627.544 538.053C626.944 532.953 627.544 527.753 627.544 527.753C628.844 526.353 629.344 524.553 629.044 522.753C628.544 520.053 627.844 515.853 627.444 512.453C627.444 512.253 627.444 512.153 627.344 511.953C624.244 514.853 620.943 517.553 619.643 521.653C618.943 523.853 616.644 525.253 614.344 524.653C606.944 522.753 599.543 522.353 592.143 524.753C589.043 529.153 584.944 534.553 581.844 538.753C579.444 541.853 581.444 546.453 585.344 546.853C589.044 547.253 594.044 547.553 600.244 547.453C609.444 547.153 617.444 546.053 622.344 545.253C625.644 544.753 627.944 541.753 627.544 538.453C627.544 538.153 627.544 538.053 627.544 538.053Z",
  fill: "#22272E"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M680.344 495.753C680.344 495.753 683.444 507.553 683.444 511.653C683.444 514.553 682.744 521.653 682.244 525.853C682.044 527.553 682.343 529.153 683.143 530.653C683.343 530.953 683.444 531.253 683.444 531.653C683.544 532.353 683.544 535.353 683.544 538.153C683.544 541.353 685.943 544.053 689.143 544.353C692.643 544.653 698.244 544.853 707.044 544.553C713.944 544.353 718.644 543.953 721.744 543.653C724.944 543.353 726.844 539.853 725.344 536.953C721.144 529.153 713.844 515.153 712.344 511.753C710.244 506.853 708.044 492.653 708.044 492.653C708.044 492.653 680.944 481.553 680.344 495.753Z",
  fill: "#F7D4D9"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M710.444 505.153C709.144 499.353 708.044 492.653 708.044 492.653C708.044 492.653 680.944 481.553 680.444 495.753C680.444 495.753 681.144 498.353 681.844 501.553C691.344 505.253 700.844 505.953 710.444 505.153Z",
  fill: "#E26E85"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M725.344 536.953C723.544 533.653 721.244 529.153 718.944 524.853C718.544 524.753 718.144 524.753 717.744 524.753C709.844 522.553 700.944 525.853 693.044 525.853C689.944 524.853 688.744 516.253 683.344 513.153C683.144 516.553 682.644 522.353 682.244 525.953C682.044 527.653 682.344 529.253 683.144 530.753C683.344 531.053 683.444 531.353 683.444 531.753C683.544 532.453 683.544 535.453 683.544 538.253C683.544 541.453 685.944 544.153 689.144 544.453C692.644 544.753 698.244 544.953 707.044 544.653C713.944 544.453 718.644 544.053 721.744 543.753C725.044 543.353 726.844 539.853 725.344 536.953Z",
  fill: "#22272E"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M676.844 233.653C676.844 233.653 684.944 246.153 687.144 270.753C688.444 284.953 686.644 334.453 687.144 339.153C687.544 342.753 694.144 387.453 700.244 428.453C703.244 448.053 708.644 467.653 711.744 480.353C713.344 487.053 711.844 491.553 710.444 494.553C710.444 494.553 708.444 501.053 698.944 501.553C687.844 502.053 684.044 500.653 678.844 498.453C676.644 497.453 672.044 494.553 670.944 488.553C668.944 477.553 666.344 457.253 660.144 435.653C652.344 408.653 642.444 377.253 638.544 352.853C638.044 349.953 635.944 340.353 633.744 331.253C631.844 323.553 629.944 316.253 628.944 313.453C625.344 303.453 625.744 303.053 624.544 300.653C622.644 296.853 618.244 301.553 613.844 283.353C613.144 280.653 612.644 276.453 612.244 271.953C611.244 260.453 610.944 246.353 610.944 246.353C610.944 246.353 661.444 221.353 676.844 233.653Z",
  fill: "#22272E"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M585.844 245.453C585.844 245.453 578.844 289.753 578.944 344.953C578.944 356.253 581.844 382.653 585.244 410.253C588.844 439.753 589.444 463.753 591.444 487.353C591.744 491.453 593.744 494.253 595.144 495.753C596.144 496.753 597.044 497.853 598.044 498.853C599.644 500.653 603.344 503.353 610.944 503.153C622.244 502.853 627.544 497.353 629.644 494.653C631.344 492.453 633.444 489.853 633.544 482.953C633.844 466.153 629.744 460.553 631.044 406.053C631.544 384.753 630.544 364.653 629.344 352.753C628.744 346.553 650.244 276.153 652.144 267.053C654.044 257.953 601.644 236.353 585.844 245.453Z",
  fill: "#22272E"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M665.944 258.353C665.944 258.353 667.844 273.253 681.144 280.753",
  stroke: "#63737A",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M633.544 331.253C631.644 323.553 629.744 316.253 628.744 313.453C625.144 303.453 625.544 303.053 624.344 300.653C622.444 296.853 618.044 301.553 613.644 283.353",
  stroke: "#63737A",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M594.444 372.153C601.513 372.153 607.244 365.885 607.244 358.153C607.244 350.421 601.513 344.153 594.444 344.153C587.374 344.153 581.644 350.421 581.644 358.153C581.644 365.885 587.374 372.153 594.444 372.153Z",
  stroke: "#63737A",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M664.344 372.153C672.02 372.153 678.244 365.885 678.244 358.153C678.244 350.421 672.02 344.153 664.344 344.153C656.667 344.153 650.444 350.421 650.444 358.153C650.444 365.885 656.667 372.153 664.344 372.153Z",
  stroke: "#63737A",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M601.143 191.753C588.343 209.053 574.843 216.853 563.343 209.453C553.443 203.053 543.343 155.853 540.043 139.353C539.343 135.753 538.943 133.653 538.943 133.653L537.843 128.753C537.843 128.753 527.243 127.053 524.643 126.253C521.943 125.453 519.143 123.953 517.043 120.153C514.943 116.353 509.243 109.953 511.943 109.053C514.643 108.153 521.843 116.953 521.843 116.953C521.843 116.953 528.143 117.153 537.743 115.953C547.343 114.753 552.243 114.753 555.243 118.753C556.943 120.953 557.943 124.853 557.943 124.853L560.143 130.753L575.143 170.653C575.143 170.653 575.843 169.353 576.943 167.253C587.643 173.353 594.643 182.353 601.143 191.753Z",
  fill: "#F7D4D9"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M595.844 198.353C597.644 196.353 599.443 194.153 601.143 191.753C594.643 182.453 587.544 173.353 576.844 167.253C576.444 168.053 576.144 168.653 575.844 169.153C584.644 177.453 591.044 187.453 595.844 198.353Z",
  fill: "#E26E85"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M575.144 166.753C585.844 172.953 594.744 182.453 601.244 191.753C602.744 189.653 604.344 187.453 605.844 185.153C597.244 176.553 587.644 168.853 578.044 162.253C576.844 163.853 575.744 165.453 575.144 166.753Z",
  fill: "white"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M599.544 131.153C599.544 131.153 593.544 135.753 586.944 148.153C584.044 153.553 580.544 158.353 577.944 162.153C587.544 168.853 597.144 176.453 605.744 185.053C607.544 182.253 609.344 179.253 611.144 176.153C626.744 148.353 609.044 126.053 599.544 131.153Z",
  fill: "#F6AE2D"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M575.144 170.653C575.144 170.653 577.244 176.453 579.044 181.653",
  stroke: "#E26E85",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M516.144 118.653C516.144 118.653 511.244 114.953 508.644 113.253C506.044 111.553 510.344 109.653 514.244 111.253C518.144 112.853 524.944 115.153 524.944 115.153C524.944 115.153 520.744 111.153 519.644 109.753C518.544 108.353 521.344 107.153 524.044 108.853C526.844 110.653 531.344 114.753 534.544 116.153C537.744 117.553 537.644 121.153 536.044 121.753C534.544 122.353 522.244 121.053 516.144 118.653Z",
  fill: "#F7D4D9"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M552.143 116.253C552.143 116.253 546.744 113.553 544.544 112.653C542.344 111.753 538.844 110.653 537.844 110.553C536.944 110.453 535.244 112.153 538.544 114.853C541.844 117.553 543.744 119.153 543.744 119.153C543.744 119.153 553.743 119.553 552.143 116.253Z",
  fill: "#F7D4D9"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M599.544 130.753C599.544 130.753 605.344 122.853 633.944 120.853C662.544 118.853 679.444 125.153 685.444 135.053C691.444 144.953 675.144 200.453 673.644 208.153C672.144 215.853 679.744 235.153 679.744 239.253C679.744 243.353 646.944 255.453 626.244 255.053C608.644 254.653 593.744 249.453 586.744 246.153C584.944 245.353 583.944 243.353 584.344 241.453C585.544 235.453 588.144 221.753 590.644 209.853C593.944 193.953 584.844 154.453 599.544 130.753Z",
  fill: "#1D62D1"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M653.744 127.153C653.644 134.153 641.644 146.453 631.444 147.453C621.244 149.353 615.844 139.853 615.844 131.953C615.844 123.953 624.743 116.553 635.143 115.553C644.943 114.453 653.844 120.053 653.744 127.153Z",
  fill: "white"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M622.244 111.953L620.744 124.753C620.744 124.753 617.144 136.153 628.444 137.553C639.744 138.953 647.444 127.953 647.844 124.153L646.344 95.453C646.444 95.553 626.044 97.453 622.244 111.953Z",
  fill: "#F7D4D9"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M636.143 118.453C631.543 119.853 626.344 119.653 621.344 119.553L620.844 124.053C626.644 124.553 632.343 122.353 636.143 118.453Z",
  fill: "#E26E85"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M621.143 229.453H568.444C566.044 229.453 564.043 227.753 563.643 225.353L557.944 189.053C557.544 186.753 559.343 184.653 561.743 184.653H614.444C616.844 184.653 618.843 186.353 619.243 188.753L624.944 225.053C625.344 227.353 623.543 229.453 621.143 229.453Z",
  fill: "#22272E"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M588.143 192.853C589.027 192.853 589.743 192.137 589.743 191.253C589.743 190.369 589.027 189.653 588.143 189.653C587.26 189.653 586.543 190.369 586.543 191.253C586.543 192.137 587.26 192.853 588.143 192.853Z",
  fill: "#F7D4D9"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M632.844 207.153C632.844 207.153 628.844 202.653 626.444 201.153C624.044 199.653 620.744 198.553 620.744 198.553L620.644 207.053C620.644 207.053 630.344 208.653 632.844 207.153Z",
  fill: "#F7D4D9"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M638.343 206.553C634.943 206.953 632.843 207.153 632.843 207.153C632.843 207.153 630.543 205.353 628.143 204.053C625.743 202.753 621.143 203.353 616.943 203.153C612.743 202.953 608.143 202.753 603.443 202.353C599.843 202.053 596.543 201.653 596.143 203.153C595.543 205.553 600.943 206.153 600.943 206.153C600.943 206.153 595.843 206.153 594.643 206.753C592.143 207.953 594.443 209.953 594.443 209.953C590.843 211.653 594.143 214.253 594.143 214.253C594.143 214.253 592.243 215.053 593.643 217.253C596.543 221.953 611.243 226.253 614.543 226.253C619.943 226.253 629.343 226.253 629.343 226.253C629.343 226.253 633.143 226.553 639.543 227.153C641.343 220.453 641.243 213.153 638.343 206.553Z",
  fill: "#F7D4D9"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M646.043 205.753C643.143 206.053 640.543 206.353 638.443 206.553C641.243 213.153 641.443 220.453 639.543 227.153C641.643 227.353 644.043 227.553 646.643 227.753C649.143 220.553 649.743 212.953 646.043 205.753Z",
  fill: "#22272E"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M671.843 184.853C675.843 193.953 679.643 202.053 679.643 202.053C676.043 202.553 658.543 204.453 645.943 205.753C649.643 213.053 649.043 220.553 646.543 227.853C653.643 228.453 662.443 229.253 672.143 230.153C696.343 232.353 711.843 231.053 715.243 218.053C718.143 206.953 714.543 196.453 702.843 169.153C692.243 173.753 681.443 178.353 671.843 184.853Z",
  fill: "#F7D4D9"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M702.943 169.153C692.243 173.753 681.443 178.353 671.843 184.853C672.143 185.453 672.443 186.153 672.743 186.753C682.043 178.753 693.843 176.853 705.743 175.653C704.843 173.553 703.943 171.453 702.943 169.153Z",
  fill: "#E26E85"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "M703.743 161.453C689.643 128.953 680.343 129.453 680.343 129.453C663.743 123.353 657.143 145.953 663.243 164.453C664.443 168.253 667.243 174.153 669.943 180.253C679.543 172.453 692.943 167.453 704.843 163.853C704.343 163.053 704.043 162.253 703.743 161.453Z",
  fill: "#F6AE2D"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  d: "M669.843 180.253C670.543 181.753 671.243 183.353 671.843 184.853C681.343 178.353 695.943 172.953 706.643 168.353C706.043 166.853 705.343 165.353 704.643 163.753C692.843 167.453 679.343 172.353 669.843 180.253Z",
  fill: "white"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  d: "M601.043 206.153C601.043 206.153 607.643 207.053 609.643 207.453C611.643 207.853 615.943 208.053 615.943 208.053",
  stroke: "#E26E85",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  d: "M594.443 209.953C594.443 209.953 601.543 211.653 604.243 212.253C606.943 212.853 615.143 213.753 615.143 213.753",
  stroke: "#E26E85",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  d: "M594.143 214.253C594.143 214.253 598.143 216.453 602.143 217.753C606.243 219.153 613.543 220.153 613.543 220.153",
  stroke: "#E26E85",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  d: "M679.643 201.953C679.643 201.953 691.643 200.053 694.543 200.253",
  stroke: "#E26E85",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  d: "M644.243 219.053C647.115 219.053 649.443 216.725 649.443 213.853C649.443 210.981 647.115 208.653 644.243 208.653C641.372 208.653 639.043 210.981 639.043 213.853C639.043 216.725 641.372 219.053 644.243 219.053Z",
  fill: "white"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  d: "M609.144 70.853C609.144 70.853 604.344 75.053 605.844 82.653C607.344 90.253 618.044 97.553 618.044 97.553C618.044 97.553 622.744 63.953 609.144 70.853Z",
  fill: "#22272E"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  d: "M610.143 73.953C610.143 73.953 608.843 93.153 608.543 100.753C608.243 108.353 611.243 118.653 622.343 120.453C633.443 122.253 644.743 116.953 648.443 102.553C652.143 88.153 651.743 71.653 639.143 69.453C626.543 67.253 610.143 73.953 610.143 73.953Z",
  fill: "#F7D4D9"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  d: "M644.743 96.753C644.743 96.753 645.143 93.153 642.343 89.553C639.543 85.853 639.943 81.753 639.943 81.753C639.943 81.753 637.843 70.953 622.143 81.253C615.543 85.553 600.043 79.953 602.843 67.753C607.143 48.953 630.743 56.953 637.543 58.153C644.343 59.353 651.043 59.353 652.243 66.353C652.243 66.353 662.843 70.853 659.743 83.253C655.643 99.453 647.443 116.253 647.443 116.253C647.443 116.253 646.543 107.053 644.743 96.753Z",
  fill: "#22272E"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  d: "M643.144 96.653C643.144 96.653 645.444 88.953 651.544 90.653C657.644 92.353 654.644 104.253 646.244 105.753",
  fill: "#F7D4D9"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  d: "M612.343 94.353C611.643 94.353 611.043 93.753 611.043 93.053V91.853C611.043 91.153 611.643 90.553 612.343 90.553C613.043 90.553 613.643 91.153 613.643 91.853V93.053C613.743 93.753 613.143 94.353 612.343 94.353Z",
  fill: "#22272E"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  d: "M627.544 94.353C626.844 94.353 626.244 93.753 626.244 93.053V91.853C626.244 91.153 626.844 90.553 627.544 90.553C628.244 90.553 628.844 91.153 628.844 91.853V93.053C628.844 93.753 628.244 94.353 627.544 94.353Z",
  fill: "#22272E"
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  d: "M609.844 87.053C609.944 85.953 611.044 83.653 613.144 83.753C616.044 83.953 617.144 85.853 616.844 87.053C616.544 88.053 614.644 87.353 613.144 87.253C611.444 87.053 609.744 87.953 609.844 87.053Z",
  fill: "#22272E"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  d: "M618.444 92.553C618.944 93.653 618.844 94.953 618.544 96.053C618.444 96.653 618.144 97.153 617.944 97.753C617.844 98.053 617.644 98.253 617.544 98.553C617.444 98.753 617.144 99.153 617.144 99.253C616.744 99.953 616.744 100.653 617.244 101.453C617.544 101.853 617.844 102.253 618.244 102.553C618.644 102.853 619.044 103.153 619.644 103.253C619.144 103.553 618.444 103.453 617.844 103.353C617.244 103.153 616.644 102.853 616.144 102.353C615.644 101.853 615.244 101.253 615.144 100.553C614.944 99.753 615.144 98.953 615.544 98.353C615.744 97.953 615.844 97.853 616.044 97.653C616.244 97.453 616.344 97.253 616.444 96.953C616.744 96.453 616.944 96.053 617.244 95.553C617.644 94.653 618.144 93.653 618.444 92.553Z",
  fill: "#22272E"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  d: "M633.543 86.853C633.443 85.453 632.243 83.553 630.043 83.753C626.943 83.953 625.544 85.653 625.944 87.153C626.244 88.353 628.443 87.353 630.043 87.153C631.843 86.853 633.543 88.053 633.543 86.853Z",
  fill: "#22272E"
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  d: "M621.243 109.453C621.043 108.753 620.943 108.053 620.843 107.453C620.743 106.453 621.543 105.653 622.443 105.653C623.543 105.653 624.943 105.353 626.743 104.753C630.543 103.353 631.043 105.953 629.943 108.553C627.143 107.953 624.043 108.853 621.243 109.453Z",
  fill: "#22272E"
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  d: "M630.043 108.653C629.043 110.853 626.843 113.153 624.243 112.653C622.543 112.353 621.643 110.953 621.243 109.553C624.043 108.853 627.143 107.953 630.043 108.653Z",
  fill: "#E26E85"
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  d: "M651.744 95.253C650.844 95.153 650.044 95.253 649.744 95.553C649.644 95.753 649.544 95.953 649.444 96.153C649.344 96.353 649.344 96.853 649.244 97.153C649.144 97.853 649.044 98.653 648.744 99.653C648.544 100.153 648.144 100.653 647.644 100.853C647.144 101.053 646.644 101.053 646.244 100.853C646.644 100.553 646.944 100.353 647.144 100.053C647.344 99.753 647.344 99.553 647.344 99.153C647.344 98.453 647.344 97.653 647.444 96.753C647.544 96.253 647.644 95.853 647.844 95.353C648.044 94.853 648.444 94.353 649.044 94.153C649.644 93.953 650.244 94.053 650.644 94.153C651.144 94.653 651.544 94.953 651.744 95.253Z",
  fill: "#22272E"
});

var _ref94 = /*#__PURE__*/React.createElement("path", {
  d: "M226.143 135.953H184.443L180.143 138.753C178.743 139.653 176.943 138.653 176.943 137.053V107.553C176.943 104.553 179.343 102.153 182.343 102.153H226.043C229.043 102.153 231.443 104.553 231.443 107.553V130.553C231.543 133.553 229.143 135.953 226.143 135.953Z",
  fill: "#F7D4D9"
});

var _ref95 = /*#__PURE__*/React.createElement("path", {
  d: "M190.443 111.653H218.243",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  d: "M190.443 119.253H218.243",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  d: "M190.443 126.853H206.443",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref98 = /*#__PURE__*/React.createElement("path", {
  d: "M328.144 302.853C328.144 302.853 345.044 311.053 365.644 332.553C387.744 355.753 393.144 369.653 390.144 382.853C387.744 393.453 387.544 387.453 365.644 388.953C343.744 390.453 322.744 390.053 314.844 389.353C306.944 388.653 264.444 377.553 250.744 364.353C237.044 351.153 240.944 327.753 251.744 304.753C262.444 281.653 324.944 297.053 328.144 302.853Z",
  fill: "#1D62D1"
});

var _ref99 = /*#__PURE__*/React.createElement("path", {
  d: "M352.343 373.453C352.343 373.453 357.243 361.653 367.843 360.153C378.343 358.653 393.243 365.553 389.443 388.753C384.943 416.253 340.143 498.053 339.443 501.353C338.743 504.653 344.543 513.153 349.943 517.453C355.343 521.753 376.843 530.853 372.843 540.253C372.843 540.253 348.843 543.653 335.043 541.953C321.243 540.253 318.343 534.153 316.143 535.153C313.943 536.153 311.343 533.253 310.843 532.053C310.343 530.853 315.443 504.653 315.443 504.653C315.443 504.653 335.343 431.953 339.643 414.553C344.043 397.153 352.343 373.453 352.343 373.453Z",
  fill: "#F7D4D9"
});

var _ref100 = /*#__PURE__*/React.createElement("path", {
  d: "M372.843 540.353C372.843 540.353 348.843 543.753 335.043 542.053C321.243 540.353 318.343 534.253 316.143 535.253C313.943 536.253 311.343 533.353 310.843 532.153C310.643 531.653 311.243 527.653 312.143 522.853L338.543 525.453C338.543 525.453 342.643 526.053 348.043 525.453C351.843 525.053 356.143 523.753 359.343 523.253C366.943 527.953 375.543 534.053 372.843 540.353Z",
  fill: "#F6AE2D"
});

var _ref101 = /*#__PURE__*/React.createElement("path", {
  d: "M331.844 328.053C331.844 328.053 345.844 336.953 357.544 350.353",
  stroke: "#F8AB5D",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref102 = /*#__PURE__*/React.createElement("path", {
  d: "M318.544 364.353C318.544 364.353 325.443 355.053 336.843 356.553C348.243 358.053 357.144 367.953 354.144 386.753C351.144 405.553 332.343 490.653 330.843 497.553C329.343 504.453 331.444 510.953 336.544 520.353C341.744 529.753 350.844 536.653 349.644 543.853C349.644 543.853 344.744 545.553 331.544 545.553C318.344 545.553 306.343 545.053 305.343 544.353C304.343 543.653 301.644 538.653 299.644 537.953C297.644 537.253 295.643 537.753 295.343 536.053C294.943 534.453 301.744 507.553 302.544 500.653C307.344 457.453 299.144 383.253 318.544 364.353Z",
  fill: "#F7D4D9"
});

var _ref103 = /*#__PURE__*/React.createElement("path", {
  d: "M349.743 543.753C349.743 543.753 344.743 545.453 331.643 545.453C318.543 545.453 306.443 544.953 305.443 544.253C304.443 543.553 301.743 538.553 299.743 537.853C297.743 537.153 295.743 537.553 295.443 535.953C295.243 535.053 297.443 525.653 299.443 516.453C301.543 517.153 306.443 518.953 307.343 520.353C308.443 522.153 310.143 527.953 313.643 529.853C316.943 531.553 333.643 523.953 342.343 528.453C346.543 534.053 350.543 538.853 349.743 543.753Z",
  fill: "#F6AE2D"
});

var _ref104 = /*#__PURE__*/React.createElement("path", {
  d: "M353.543 371.053C354.743 375.353 355.043 380.553 354.143 386.653C351.143 405.453 332.343 490.553 330.843 497.453C329.343 504.353 331.443 510.853 336.543 520.253C337.443 521.953 338.543 523.653 339.743 525.153",
  stroke: "#E26E85",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref105 = /*#__PURE__*/React.createElement("path", {
  d: "M321.443 203.553C321.443 203.553 327.443 201.653 341.843 224.753C356.143 247.853 355.743 246.553 355.743 246.553C355.743 246.553 394.744 236.053 398.444 236.153C402.144 236.253 408.244 248.053 400.444 254.753C394.444 259.953 360.043 276.653 349.243 276.753C342.443 276.753 336.643 273.453 319.843 248.553C301.443 221.553 315.943 201.053 321.443 203.553Z",
  fill: "#77A1E3"
});

var _ref106 = /*#__PURE__*/React.createElement("path", {
  d: "M355.743 246.653C355.743 246.653 346.543 248.453 343.543 255.653",
  stroke: "#F6AE2D",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref107 = /*#__PURE__*/React.createElement("path", {
  d: "M414.044 228.853C414.044 228.853 414.344 226.453 414.044 222.253C413.744 218.053 412.244 212.653 412.244 212.653C412.244 212.653 410.044 211.553 409.544 214.853C409.044 218.153 407.744 225.553 407.744 225.553C407.744 225.553 410.944 232.153 414.044 228.853Z",
  fill: "#F7D4D9"
});

var _ref108 = /*#__PURE__*/React.createElement("path", {
  d: "M398.844 270.653H359.344C356.844 270.653 354.944 268.453 355.344 265.953L364.944 202.853C365.444 199.753 368.044 197.553 371.144 197.553H410.643C413.143 197.553 415.043 199.753 414.643 202.253L405.044 265.353C404.644 268.453 401.944 270.653 398.844 270.653Z",
  fill: "#22272E"
});

var _ref109 = /*#__PURE__*/React.createElement("path", {
  d: "M397.344 199.553H384.844C383.744 199.553 382.944 198.653 383.144 197.553C383.344 196.453 384.444 195.553 385.544 195.553H398.044C399.144 195.553 399.944 196.453 399.744 197.553C399.444 198.653 398.444 199.553 397.344 199.553Z",
  fill: "#1D62D1"
});

var _ref110 = /*#__PURE__*/React.createElement("path", {
  d: "M411.543 222.953C411.543 222.953 397.344 222.053 394.944 222.353C392.644 222.553 391.843 224.853 394.343 225.853C396.243 226.653 402.944 227.753 402.944 227.753C402.944 227.753 389.343 230.153 387.843 231.453C386.343 232.853 387.143 234.353 388.443 234.753C388.443 234.753 385.243 236.453 387.543 238.553C389.843 240.653 398.244 241.453 398.244 241.453C398.244 241.453 390.543 240.353 390.343 242.353C390.243 244.253 400.543 246.553 404.643 246.053C410.743 245.253 410.143 243.453 410.743 241.753C411.344 240.053 413.144 231.753 413.944 228.853C414.044 228.853 414.243 224.553 411.543 222.953Z",
  fill: "#F7D4D9"
});

var _ref111 = /*#__PURE__*/React.createElement("path", {
  d: "M402.244 227.853C402.244 227.853 410.244 229.553 411.044 229.453",
  stroke: "#E26E85",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref112 = /*#__PURE__*/React.createElement("path", {
  d: "M388.443 234.853C388.443 234.853 389.943 235.353 393.943 235.453C397.943 235.553 409.743 234.253 409.743 234.253",
  stroke: "#E26E85",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref113 = /*#__PURE__*/React.createElement("path", {
  d: "M396.344 241.253C396.344 241.253 404.444 242.053 407.844 241.253",
  stroke: "#E26E85",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref114 = /*#__PURE__*/React.createElement("path", {
  d: "M321.743 225.253C321.743 225.253 331.643 212.753 325.843 192.053C322.643 180.753 315.043 174.353 317.743 161.253C320.643 146.553 325.843 144.853 310.443 139.953C310.443 139.953 287.743 133.853 273.743 144.153C264.743 150.753 264.343 156.953 264.643 169.653C264.843 179.153 254.143 169.853 250.843 187.553C249.043 197.153 248.743 195.353 239.943 203.253C227.143 214.753 240.543 254.053 272.443 258.553C304.343 263.053 319.843 240.853 321.743 225.253Z",
  fill: "#22272E"
});

var _ref115 = /*#__PURE__*/React.createElement("path", {
  d: "M246.844 217.553C247.044 211.053 251.444 205.453 257.544 203.553C263.644 201.653 272.744 199.453 283.744 198.553C304.344 196.853 319.044 200.553 320.844 202.553C322.644 204.553 323.244 214.853 324.744 219.153C326.244 223.453 337.144 233.253 334.944 244.953C332.744 256.653 328.644 262.553 327.344 267.753C326.044 272.953 324.944 279.653 325.144 283.753C325.344 287.853 331.044 303.253 331.644 306.553C332.244 309.853 320.844 320.053 297.344 321.053C277.944 321.853 258.044 315.453 250.844 310.653C249.044 309.453 248.244 307.153 248.944 305.053C250.844 299.053 255.044 284.953 255.644 280.153C256.344 273.853 250.244 252.353 248.244 237.253C247.044 229.453 246.644 222.753 246.844 217.553Z",
  fill: "#F6AE2D"
});

var _ref116 = /*#__PURE__*/React.createElement("path", {
  d: "M272.244 196.953C272.244 196.953 270.444 208.653 278.544 209.153C286.644 209.653 283.144 211.653 284.944 215.753C286.844 219.953 292.244 218.353 292.944 217.753C297.144 214.453 298.844 220.553 302.944 219.853C307.044 219.153 305.444 215.753 307.544 214.953C309.644 214.153 313.944 214.953 312.344 209.553C310.644 203.653 317.044 208.353 313.744 201.253C309.944 192.953 290.844 193.853 279.344 196.353C267.844 198.853 272.444 194.953 272.244 196.953Z",
  fill: "white"
});

var _ref117 = /*#__PURE__*/React.createElement("path", {
  d: "M305.644 190.653C305.644 190.653 305.944 200.153 306.344 202.353C306.644 204.553 310.044 214.553 299.344 214.053C293.344 213.753 288.844 210.353 286.044 207.453C283.844 205.153 282.744 202.053 282.844 198.853L283.744 182.253C283.744 182.153 303.344 179.353 305.644 190.653Z",
  fill: "#F7D4D9"
});

var _ref118 = /*#__PURE__*/React.createElement("path", {
  d: "M290.344 187.553C291.044 196.453 298.244 200.553 306.144 201.253C305.944 199.353 305.844 196.053 305.744 193.553C300.744 197.053 293.944 192.353 290.344 187.553Z",
  fill: "#E26E85"
});

var _ref119 = /*#__PURE__*/React.createElement("path", {
  d: "M314.644 152.553C300.744 149.653 285.444 152.853 272.244 158.653C272.244 158.753 272.244 158.853 272.244 158.953C272.844 181.853 280.444 194.353 293.444 196.653C306.444 198.953 316.044 190.853 314.844 176.353C314.144 166.353 314.444 157.253 314.644 152.553Z",
  fill: "#F7D4D9"
});

var _ref120 = /*#__PURE__*/React.createElement("path", {
  d: "M272.244 158.553C285.444 152.753 300.744 149.553 314.644 152.453C314.744 150.253 314.844 149.053 314.844 149.053",
  fill: "#F7D4D9"
});

var _ref121 = /*#__PURE__*/React.createElement("path", {
  d: "M311.844 158.553C306.544 156.053 305.544 164.653 293.744 160.653C290.644 159.553 287.244 156.053 286.444 163.653C286.044 167.253 287.544 170.753 282.744 177.553C278.844 183.153 293.244 200.253 273.844 206.953C260.544 211.553 253.544 201.753 246.044 213.353C241.044 221.053 250.544 197.453 268.344 186.353C276.744 181.153 269.844 164.853 269.344 161.053C268.944 157.253 271.044 149.553 283.744 146.553C296.444 143.553 310.344 132.753 319.244 141.553C325.444 147.653 324.244 164.253 311.844 158.553Z",
  fill: "#22272E"
});

var _ref122 = /*#__PURE__*/React.createElement("path", {
  d: "M262.744 210.153C257.544 205.253 249.044 207.053 245.944 213.453C242.544 220.653 236.844 232.853 231.244 246.153C222.344 267.453 218.644 287.953 231.244 294.653C243.844 301.353 260.944 287.953 269.844 277.353C278.744 266.753 291.044 250.353 291.044 250.353C291.044 250.353 289.144 237.453 280.044 236.753L262.944 249.653C262.944 249.653 266.944 240.453 268.344 235.753C269.844 231.053 269.544 216.653 262.944 210.253C262.844 210.253 262.744 210.153 262.744 210.153Z",
  fill: "#77A1E3"
});

var _ref123 = /*#__PURE__*/React.createElement("path", {
  d: "M262.944 249.653C262.944 249.653 238.944 264.753 234.744 272.653",
  stroke: "#F6AE2D",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref124 = /*#__PURE__*/React.createElement("path", {
  d: "M279.944 236.753C279.944 236.753 295.944 226.253 297.244 225.753C298.544 225.153 308.344 227.453 309.344 227.953C310.344 228.453 312.344 233.253 312.344 233.253C312.344 233.253 320.344 237.053 320.544 237.753C320.744 238.453 319.144 240.553 318.644 240.853C318.144 241.053 315.944 241.253 315.544 241.353C315.144 241.453 311.044 248.053 309.044 249.653C307.044 251.253 297.544 249.853 296.144 249.853C294.644 249.853 288.244 251.853 288.244 251.853C288.244 251.853 284.044 250.953 280.944 245.853C277.844 240.753 279.944 236.753 279.944 236.753Z",
  fill: "#F7D4D9"
});

var _ref125 = /*#__PURE__*/React.createElement("path", {
  d: "M327.943 235.453L330.743 237.453C331.143 237.753 330.943 238.353 330.443 238.353L327.043 238.453L291.443 227.853C290.443 227.553 289.743 226.653 290.043 225.753C290.343 224.853 291.343 224.453 292.343 224.753L327.943 235.453Z",
  fill: "white"
});

var _ref126 = /*#__PURE__*/React.createElement("path", {
  d: "M311.843 234.053C311.843 234.053 319.143 233.553 319.543 232.753C320.043 231.953 319.743 230.653 318.643 229.753C317.543 228.853 305.943 228.353 303.443 228.153C300.943 227.953 297.643 228.553 295.443 230.353C293.343 232.353 304.643 239.353 311.843 234.053Z",
  fill: "#F7D4D9"
});

var _ref127 = /*#__PURE__*/React.createElement("path", {
  d: "M315.643 241.353C315.643 241.353 310.143 240.553 309.443 240.553C308.743 240.553 306.443 240.553 306.443 240.553",
  stroke: "#E26E85",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref128 = /*#__PURE__*/React.createElement("path", {
  d: "M312.443 245.753C312.443 245.753 308.643 246.053 307.243 246.253C305.843 246.353 304.943 246.253 304.943 246.253",
  stroke: "#E26E85",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref129 = /*#__PURE__*/React.createElement("path", {
  d: "M301.543 185.253C299.443 185.153 296.943 184.553 294.943 182.353",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref130 = /*#__PURE__*/React.createElement("path", {
  d: "M310.344 174.953C311.244 174.953 312.044 174.153 312.044 173.253V172.253C312.044 171.353 311.244 170.553 310.344 170.553C309.444 170.553 308.644 171.353 308.644 172.253V173.253C308.644 174.153 309.344 174.953 310.344 174.953Z",
  fill: "#22272E"
});

var _ref131 = /*#__PURE__*/React.createElement("path", {
  d: "M294.743 174.953C295.643 174.953 296.443 174.153 296.443 173.253V172.253C296.443 171.353 295.643 170.553 294.743 170.553C293.843 170.553 293.043 171.353 293.043 172.253V173.253C293.043 174.153 293.843 174.953 294.743 174.953Z",
  fill: "#22272E"
});

var _ref132 = /*#__PURE__*/React.createElement("path", {
  d: "M304.644 181.653C305.644 181.353 306.244 180.753 306.744 180.153C307.244 179.553 307.544 178.853 307.544 178.253C307.544 178.053 307.544 177.953 307.444 177.753L307.244 177.053C307.144 176.553 307.044 176.153 306.944 175.553C306.844 174.553 306.844 173.653 307.044 172.653C307.644 173.453 307.944 174.453 308.344 175.253L308.844 176.453L309.144 177.153C309.244 177.453 309.344 177.753 309.344 178.053C309.344 178.653 309.144 179.353 308.844 179.853C308.544 180.353 308.144 180.753 307.644 181.053C307.144 181.353 306.644 181.553 306.144 181.653C305.644 181.953 305.144 181.953 304.644 181.653Z",
  fill: "#22272E"
});

var _ref133 = /*#__PURE__*/React.createElement("path", {
  d: "M289.943 164.553C290.043 163.553 291.243 162.953 293.143 162.453C297.143 161.953 298.743 163.553 298.143 165.553C297.643 167.153 294.843 165.653 293.043 165.653C291.543 165.553 289.943 165.453 289.943 164.553Z",
  fill: "#22272E"
});

var _ref134 = /*#__PURE__*/React.createElement("path", {
  d: "M314.144 164.453C314.144 163.453 313.144 162.953 311.744 162.353C308.744 161.753 307.444 163.353 307.844 165.153C308.244 166.653 310.344 165.353 311.744 165.353C312.944 165.453 314.244 165.353 314.144 164.453Z",
  fill: "#22272E"
});

var _ref135 = /*#__PURE__*/React.createElement("path", {
  d: "M169.543 177.253C169.543 177.253 169.243 184.153 170.443 190.253C170.843 192.153 169.743 194.153 167.943 194.853C166.743 195.253 165.343 195.453 164.043 194.653C160.843 192.653 165.843 171.353 169.543 177.253Z",
  fill: "#22272E"
});

var _ref136 = /*#__PURE__*/React.createElement("path", {
  d: "M124.443 185.153C124.443 185.153 124.543 192.153 125.143 196.653C125.443 199.053 127.843 200.753 130.243 200.153C130.543 200.053 130.743 199.953 130.943 199.853C132.743 198.653 131.443 182.253 131.443 182.253C131.443 182.253 124.843 182.353 124.443 185.153Z",
  fill: "#22272E"
});

var _ref137 = /*#__PURE__*/React.createElement("path", {
  d: "M120.144 170.353C120.144 170.353 120.244 179.753 115.344 190.053C114.844 191.153 115.144 192.453 116.044 193.253C116.044 193.253 116.044 193.253 116.144 193.253C117.444 194.353 119.444 193.953 120.244 192.353C122.244 188.353 126.044 179.553 125.744 170.253C125.444 157.753 120.144 170.353 120.144 170.353Z",
  fill: "#22272E"
});

var _ref138 = /*#__PURE__*/React.createElement("path", {
  d: "M162.344 544.353C162.444 545.853 159.844 548.653 154.644 548.653C149.444 548.653 152.044 548.653 133.844 548.653C115.644 548.653 109.144 547.753 109.844 542.153C110.544 536.553 109.344 532.353 109.344 532.353C109.344 532.353 107.144 531.253 106.744 530.353C106.344 529.453 106.744 528.453 108.444 519.953C108.544 519.453 108.644 518.853 108.744 518.253C110.244 509.453 111.544 495.253 111.544 495.253C115.444 493.353 142.944 498.553 142.944 498.553C142.944 498.553 140.444 509.153 141.744 514.253C141.844 514.553 141.844 514.753 141.944 514.953C143.544 519.853 162.244 542.953 162.344 544.353Z",
  fill: "#B28D93"
});

var _ref139 = /*#__PURE__*/React.createElement("path", {
  d: "M141.344 511.053C141.244 505.653 142.944 498.553 142.944 498.553C142.944 498.553 115.444 493.353 111.544 495.253C111.544 495.253 111.244 498.453 110.744 502.853C119.144 510.653 130.544 512.553 141.344 511.053Z",
  fill: "#896068"
});

var _ref140 = /*#__PURE__*/React.createElement("path", {
  d: "M152.144 530.253C145.844 527.153 133.944 526.853 123.944 529.553C121.744 530.153 119.444 528.853 118.944 526.653C118.244 524.053 117.344 521.353 116.944 518.153C116.544 514.853 112.444 515.453 109.644 512.353C109.244 515.053 108.844 517.753 108.444 519.853C106.744 528.353 106.444 529.353 106.744 530.253C107.144 531.153 109.344 532.253 109.344 532.253C109.344 532.253 110.444 536.553 109.844 542.053C109.144 547.653 115.644 548.553 133.844 548.553C152.044 548.553 149.444 548.553 154.644 548.553C159.844 548.553 162.444 545.753 162.344 544.253C162.244 543.653 157.244 537.053 152.144 530.253Z",
  fill: "#22272E"
});

var _ref141 = /*#__PURE__*/React.createElement("path", {
  d: "M208.444 495.253C208.444 495.253 208.244 511.353 207.144 519.953C206.144 528.453 205.844 529.453 206.244 530.353C206.644 531.253 209.044 532.353 209.044 532.353C209.044 532.353 210.544 536.653 210.244 542.153C209.944 547.753 216.544 548.653 234.744 548.653C252.944 548.653 250.344 548.653 255.544 548.653C260.744 548.653 263.144 545.853 262.944 544.353C262.744 542.853 242.244 519.853 240.244 514.953C238.244 510.153 240.044 498.453 240.044 498.453C240.044 498.453 212.244 493.353 208.444 495.253Z",
  fill: "#B28D93"
});

var _ref142 = /*#__PURE__*/React.createElement("path", {
  d: "M239.344 506.853C239.444 502.553 240.044 498.553 240.044 498.553C240.044 498.553 212.144 493.353 208.444 495.253C208.444 495.253 208.344 500.353 208.144 506.253C217.344 512.653 228.944 510.353 239.344 506.853Z",
  fill: "#896068"
});

var _ref143 = /*#__PURE__*/React.createElement("path", {
  d: "M250.644 528.953C239.944 526.953 228.244 531.953 218.544 527.553C216.244 526.953 215.244 522.153 213.644 519.153C212.344 516.653 210.544 515.853 207.644 514.453C207.544 516.453 207.344 518.353 207.144 519.953C206.144 528.453 205.844 529.453 206.244 530.353C206.644 531.253 209.044 532.353 209.044 532.353C209.044 532.353 210.544 536.653 210.244 542.153C209.944 547.753 216.544 548.653 234.744 548.653C252.944 548.653 250.344 548.653 255.544 548.653C260.744 548.653 263.144 545.853 262.944 544.353C262.844 543.553 256.644 536.253 250.644 528.953Z",
  fill: "#22272E"
});

var _ref144 = /*#__PURE__*/React.createElement("path", {
  d: "M97.0436 305.453C97.0436 305.453 88.8435 313.853 88.7435 333.253C88.6435 356.353 103.344 372.953 127.444 372.953C151.544 372.953 199.444 372.253 216.544 372.953C233.644 373.653 231.344 335.953 218.744 324.353C206.144 312.853 108.544 291.353 97.0436 305.453Z",
  fill: "#22272E"
});

var _ref145 = /*#__PURE__*/React.createElement("path", {
  d: "M120.443 363.753C122.843 356.253 131.343 344.253 146.843 347.353C163.643 350.653 171.843 356.353 163.943 405.253C157.043 447.653 144.743 495.953 142.843 503.053C142.643 503.653 142.243 504.153 141.643 504.353C139.843 504.953 135.743 506.253 129.443 506.253C122.043 506.253 113.943 503.553 110.743 500.753C110.043 500.153 109.643 499.153 109.743 498.253C110.543 486.253 116.543 394.153 117.043 387.253C118.043 377.353 118.743 369.053 120.443 363.753Z",
  fill: "#22272E"
});

var _ref146 = /*#__PURE__*/React.createElement("path", {
  d: "M232.444 347.353C249.644 348.053 258.744 359.253 253.944 405.253C249.644 446.453 241.944 493.553 240.544 502.453C240.344 503.453 239.744 504.253 238.744 504.553C236.744 505.253 232.944 506.153 227.344 506.153C220.344 506.153 212.444 503.753 208.744 501.053C207.644 500.253 207.044 498.953 207.144 497.653C207.444 486.953 208.644 430.353 204.644 387.353C202.044 359.953 216.344 346.653 232.444 347.353Z",
  fill: "#22272E"
});

var _ref147 = /*#__PURE__*/React.createElement("path", {
  d: "M149.044 375.453C156.72 375.453 162.944 370.259 162.944 363.853C162.944 357.446 156.72 352.253 149.044 352.253C141.367 352.253 135.144 357.446 135.144 363.853C135.144 370.259 141.367 375.453 149.044 375.453Z",
  stroke: "#63737A",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref148 = /*#__PURE__*/React.createElement("path", {
  d: "M234.044 375.453C241.72 375.453 247.944 370.259 247.944 363.853C247.944 357.446 241.72 352.253 234.044 352.253C226.367 352.253 220.144 357.446 220.144 363.853C220.144 370.259 226.367 375.453 234.044 375.453Z",
  stroke: "#63737A",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref149 = /*#__PURE__*/React.createElement("path", {
  d: "M213.643 261.253C213.043 259.653 212.643 258.653 212.643 258.653L180.543 265.353L181.143 281.253C193.443 277.853 204.643 270.453 213.643 261.253Z",
  fill: "#896068"
});

var _ref150 = /*#__PURE__*/React.createElement("path", {
  d: "M222.143 286.553C220.443 279.253 215.743 266.653 213.643 261.253C204.643 270.553 193.443 277.853 181.043 281.153L181.543 296.453L195.743 340.853L212.543 331.253C225.143 303.753 224.343 295.953 222.143 286.553Z",
  fill: "#B28D93"
});

var _ref151 = /*#__PURE__*/React.createElement("path", {
  d: "M68.4436 265.053C66.9436 264.453 66.2436 262.753 66.8436 261.253C69.9436 252.453 80.6436 223.753 89.6436 213.753C100.444 201.853 134.544 201.153 149.044 201.153C163.544 201.153 183.944 203.753 192.044 210.753C199.044 216.753 210.644 246.553 213.844 254.953C214.344 256.253 213.844 257.753 212.744 258.553C208.744 261.253 199.244 267.353 190.244 270.653L194.544 331.253C194.544 331.253 101.144 329.853 97.4436 328.053C93.7436 326.153 88.9436 304.353 89.6436 302.053C90.3436 299.853 97.0436 274.253 97.0436 274.253C97.0436 274.253 78.2436 269.353 68.4436 265.053Z",
  fill: "#1D62D1"
});

var _ref152 = /*#__PURE__*/React.createElement("path", {
  d: "M97.0435 274.253C97.0435 274.253 100.743 275.253 102.243 275.553C102.243 275.553 110.443 252.353 111.543 245.853C112.643 239.353 112.643 234.553 111.543 232.353",
  stroke: "#F8AB5D",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref153 = /*#__PURE__*/React.createElement("path", {
  d: "M190.243 270.653C190.243 270.653 189.343 243.453 188.943 237.853C188.543 232.253 188.343 227.453 186.543 223.753",
  stroke: "#F8AB5D",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref154 = /*#__PURE__*/React.createElement("path", {
  d: "M97.0435 274.253C97.0435 274.253 77.0436 268.853 68.8436 265.253C68.8436 265.253 68.5436 266.053 68.1436 267.353C76.4436 273.453 85.4436 278.953 95.1436 281.253L97.0435 274.253Z",
  fill: "#896068"
});

var _ref155 = /*#__PURE__*/React.createElement("path", {
  d: "M144.544 324.353C141.544 324.053 131.344 326.553 131.344 326.553C121.344 316.353 92.5435 291.353 92.5435 291.353L95.2435 281.153C85.5435 278.853 76.5435 273.353 68.2435 267.253C66.2435 273.253 60.7435 291.053 62.2435 300.153C64.1435 311.253 95.0435 331.053 119.544 343.653C119.544 343.653 122.844 347.253 131.044 349.753C133.744 350.553 137.444 351.853 138.944 352.053C140.444 352.253 144.344 351.853 146.744 352.053C149.144 352.253 150.244 350.153 152.844 350.453C155.444 350.753 156.144 349.053 158.044 350.153C159.944 351.253 161.344 349.053 161.344 346.853C161.244 344.753 147.544 324.753 144.544 324.353Z",
  fill: "#B28D93"
});

var _ref156 = /*#__PURE__*/React.createElement("path", {
  d: "M92.5435 291.453C92.5435 291.453 85.3436 288.653 79.6436 291.453",
  stroke: "#896068",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref157 = /*#__PURE__*/React.createElement("path", {
  d: "M165.744 208.853C166.144 218.453 157.844 226.053 147.344 225.753C136.844 225.453 127.944 217.353 127.644 207.753C127.244 198.153 136.344 195.153 146.944 195.453C157.444 195.753 165.444 199.253 165.744 208.853Z",
  fill: "white"
});

var _ref158 = /*#__PURE__*/React.createElement("path", {
  d: "M132.543 183.853C132.543 183.853 132.743 203.753 132.543 207.453C132.343 211.153 136.643 220.253 149.143 220.253C161.643 220.253 162.243 208.053 162.043 207.453C161.843 206.853 161.344 188.053 160.744 186.853C160.344 185.653 136.143 179.053 132.543 183.853Z",
  fill: "#B28D93"
});

var _ref159 = /*#__PURE__*/React.createElement("path", {
  d: "M139.744 199.753C145.644 206.453 153.844 208.953 162.044 208.553C162.144 207.953 162.044 207.553 162.044 207.453C162.044 207.253 161.944 205.753 161.844 203.553C154.444 205.853 147.144 201.853 139.744 199.753Z",
  fill: "#896068"
});

var _ref160 = /*#__PURE__*/React.createElement("path", {
  d: "M166.444 185.153C166.444 185.153 171.244 178.253 172.444 167.753C173.844 156.153 168.343 148.053 160.843 144.453C155.643 141.953 136.944 137.653 125.344 148.953C118.044 156.053 117.044 179.153 128.444 184.653C143.044 191.653 130.644 193.153 131.244 193.753C131.244 193.753 131.544 195.453 135.744 190.953C139.944 186.353 166.444 185.153 166.444 185.153Z",
  fill: "#22272E"
});

var _ref161 = /*#__PURE__*/React.createElement("path", {
  d: "M169.544 170.853C169.544 170.853 168.744 184.053 168.144 191.953C167.544 199.853 163.544 207.953 150.044 208.353C136.544 208.753 130.144 198.453 128.644 190.753C126.444 179.053 122.644 156.453 141.344 153.853C160.044 151.253 169.544 157.153 169.544 170.853Z",
  fill: "#B28D93"
});

var _ref162 = /*#__PURE__*/React.createElement("path", {
  d: "M169.543 162.753C169.543 162.753 157.943 176.153 140.443 165.553C134.043 161.653 132.543 167.453 132.543 169.753C132.543 172.953 134.043 179.253 129.043 181.853C127.043 182.853 123.943 176.653 125.643 162.753C127.343 148.853 153.643 149.953 162.343 150.953C171.043 151.953 170.943 156.553 169.543 162.753Z",
  fill: "#22272E"
});

var _ref163 = /*#__PURE__*/React.createElement("path", {
  d: "M131.043 180.453C131.043 180.453 129.043 172.153 123.544 173.853C117.944 175.553 120.443 189.053 129.443 190.753",
  fill: "#B28D93"
});

var _ref164 = /*#__PURE__*/React.createElement("path", {
  d: "M150.844 198.753C148.644 198.653 146.044 198.053 143.944 195.753",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref165 = /*#__PURE__*/React.createElement("path", {
  d: "M161.844 183.753C162.844 183.753 163.644 182.953 163.644 181.953V180.953C163.644 179.953 162.844 179.153 161.844 179.153C160.844 179.153 160.044 179.953 160.044 180.953V181.953C160.144 182.953 160.844 183.753 161.844 183.753Z",
  fill: "#22272E"
});

var _ref166 = /*#__PURE__*/React.createElement("path", {
  d: "M144.344 183.753C145.344 183.753 146.144 182.953 146.144 181.953V180.953C146.144 179.953 145.344 179.153 144.344 179.153C143.344 179.153 142.544 179.953 142.544 180.953V181.953C142.544 182.953 143.344 183.753 144.344 183.753Z",
  fill: "#22272E"
});

var _ref167 = /*#__PURE__*/React.createElement("path", {
  d: "M165.444 174.553C165.344 173.353 164.144 171.753 161.844 171.853C158.744 171.953 158.244 173.753 158.644 174.953C158.944 175.953 160.344 174.853 161.944 174.653C163.744 174.553 165.544 175.553 165.444 174.553Z",
  fill: "#22272E"
});

var _ref168 = /*#__PURE__*/React.createElement("path", {
  d: "M152.744 194.553C154.244 194.553 155.544 193.853 156.144 192.853C156.444 192.353 156.744 191.753 156.844 191.053C157.044 190.453 157.044 189.753 157.144 189.053C157.244 187.653 157.044 186.353 156.944 184.853C156.844 183.353 156.644 181.853 156.944 180.353C157.444 181.753 157.944 183.153 158.344 184.553C158.544 185.253 158.744 186.053 158.844 186.753C158.944 187.553 159.044 188.353 158.944 189.053C158.844 190.653 158.444 192.353 157.244 193.553C156.644 194.153 155.844 194.653 155.044 194.753C154.244 194.953 153.444 194.853 152.744 194.553Z",
  fill: "#22272E"
});

var _ref169 = /*#__PURE__*/React.createElement("path", {
  d: "M139.744 174.553C139.844 173.353 141.144 171.753 143.544 171.853C146.944 172.053 147.444 173.753 147.044 174.953C146.644 175.953 145.244 174.853 143.544 174.653C141.544 174.553 139.644 175.553 139.744 174.553Z",
  fill: "#22272E"
});

var _ref170 = /*#__PURE__*/React.createElement("path", {
  d: "M123.644 179.453C123.744 179.053 123.944 178.553 124.344 178.253C124.544 178.053 124.944 178.053 125.244 178.153C125.444 178.153 125.544 178.253 125.644 178.353C125.744 178.453 125.944 178.553 125.944 178.653C126.344 179.053 126.544 179.453 126.744 179.853C126.944 180.253 127.044 180.753 127.144 181.153C127.344 182.053 127.244 182.853 127.144 183.553C127.144 183.853 127.044 184.153 127.144 184.453C127.244 184.753 127.544 184.953 127.844 185.253C127.444 185.353 126.944 185.353 126.444 185.053C126.044 184.753 125.744 184.153 125.644 183.753C125.444 182.853 125.344 182.153 125.244 181.453C125.144 181.153 125.144 180.753 125.044 180.453C124.944 180.153 124.844 179.853 124.744 179.553C124.644 179.353 124.644 179.153 124.344 179.153C124.444 179.053 124.044 179.253 123.644 179.453Z",
  fill: "#22272E"
});

var _ref171 = /*#__PURE__*/React.createElement("path", {
  d: "M142.644 190.653C147.338 190.653 151.144 186.847 151.144 182.153C151.144 177.459 147.338 173.653 142.644 173.653C137.949 173.653 134.144 177.459 134.144 182.153C134.144 186.847 137.949 190.653 142.644 190.653Z",
  stroke: "white",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref172 = /*#__PURE__*/React.createElement("path", {
  d: "M165.544 190.653C169.796 190.653 173.244 186.847 173.244 182.153C173.244 177.459 169.796 173.653 165.544 173.653C161.291 173.653 157.844 177.459 157.844 182.153C157.844 186.847 161.291 190.653 165.544 190.653Z",
  stroke: "white",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref173 = /*#__PURE__*/React.createElement("path", {
  d: "M134.644 179.253H133.243C132.643 179.253 132.044 179.053 131.544 178.653L129.844 177.253",
  stroke: "white",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref174 = /*#__PURE__*/React.createElement("path", {
  d: "M150.943 180.353C150.943 180.353 155.643 178.653 157.843 180.353",
  stroke: "white",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref175 = /*#__PURE__*/React.createElement("path", {
  d: "M235.444 356.353H139.444C136.644 356.353 134.544 353.653 135.344 350.953L142.544 324.453L149.844 297.453C150.644 294.453 153.344 292.353 156.444 292.353H222.344H252.444C255.244 292.353 257.344 295.053 256.544 297.753L242.044 351.253C241.244 354.253 238.544 356.353 235.444 356.353Z",
  fill: "#22272E"
});

var _ref176 = /*#__PURE__*/React.createElement("path", {
  d: "M256.544 297.853L242.044 351.253C241.244 354.253 238.544 356.353 235.444 356.353H139.444",
  stroke: "#63737A",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref177 = /*#__PURE__*/React.createElement("path", {
  d: "M203.621 329.83C206.94 326.915 207.799 322.466 205.54 319.893C203.28 317.32 198.757 317.599 195.438 320.514C192.119 323.43 191.259 327.879 193.519 330.451C195.779 333.024 200.301 332.746 203.621 329.83Z",
  fill: "#63737A"
});

var _ref178 = /*#__PURE__*/React.createElement("path", {
  d: "M120.144 161.553C120.144 161.553 118.744 169.453 112.844 176.153C111.744 177.453 111.844 179.353 113.244 180.353C114.544 181.353 116.344 181.153 117.344 179.853C119.644 176.953 123.644 171.453 125.944 165.553C127.944 160.353 120.644 159.653 120.144 161.553Z",
  fill: "#22272E"
});

function SvgSignUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 732,
    height: 549,
    viewBox: "0 0 732 549",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_301_3671",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 62,
    width: 676,
    height: 368
  }, _ref3), _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157, _ref158, _ref159, _ref160, _ref161, _ref162, _ref163, _ref164, _ref165, _ref166, _ref167, _ref168, _ref169, _ref170, _ref171, _ref172, _ref173, _ref174, _ref175, _ref176, _ref177, _ref178);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUp);
export default __webpack_public_path__ + "static/media/SignUp.3744901e.svg";
export { ForwardRef as ReactComponent };